import { ROLE_CATEGORIES, COMPANIES } from './constants';

// Assigns a role, category, and company to a profile based on its index
export const assignRole = (index) => {
  const categoryIndex = index % ROLE_CATEGORIES.length;
  const category = ROLE_CATEGORIES[categoryIndex];
  const roleIndex = index % category.roles.length;
  const companyIndex = index % COMPANIES.length;
  
  return {
    category: category.id,
    role: category.roles[roleIndex],
    company: COMPANIES[companyIndex]
  };
};

// Generates social media handles from name
export const generateSocialHandles = (firstName, lastName) => {
  const username = `${firstName.toLowerCase()}-${lastName.toLowerCase()}`;
  const handle = `${firstName.toLowerCase()}${lastName.toLowerCase()}`;
  
  return {
    linkedin: `linkedin.com/in/${username}`,
    twitter: `@${handle}`,
    github: `github.com/${handle}`
  };
};
